export default __webpack_public_path__ + "images/maria-clara-usuario.jpg";